import { Mail, Phone, Instagram } from "lucide-react";
import { useLanguage } from "@/i18n";
import { WidgetEmbed } from "@/components/WidgetEmbed";

export const Booking = ({ settings }) => {
  const { t, pick } = useLanguage();
  return (
    <section id="booking" className="px-4 sm:px-8 lg:px-16 py-20 sm:py-28 border-t border-white/10" data-testid="booking-widget-container">
      <p className="font-mono2 text-[11px] tracking-[0.3em] uppercase text-zinc-500 mb-3">05 —</p>
      <h2 className="font-display uppercase text-5xl sm:text-7xl tracking-wide">{t("booking_title")}</h2>
      <p className="text-zinc-400 mt-3 max-w-xl">{pick(settings.booking_note)}</p>

      {settings.widget_embed_code ? (
        <WidgetEmbed code={settings.widget_embed_code} />
      ) : (
        <div className="mt-10 flex flex-wrap gap-3" data-testid="booking-contact-fallback">
          {settings.email && (
            <a href={`mailto:${settings.email}`} data-testid="booking-email-link"
              className="inline-flex items-center gap-2 bg-white text-black font-mono2 text-[11px] tracking-[0.25em] uppercase px-7 py-4 hover:bg-[#E63946] hover:text-white transition-colors duration-300">
              <Mail size={14} /> {settings.email}
            </a>
          )}
          {settings.phone && (
            <a href={`tel:${settings.phone.replace(/[^+\d]/g, "")}`} data-testid="booking-phone-link"
              className="inline-flex items-center gap-2 border border-white/25 font-mono2 text-[11px] tracking-[0.25em] uppercase px-7 py-4 hover:border-white transition-colors duration-300">
              <Phone size={14} /> {settings.phone}
            </a>
          )}
          {settings.instagram && (
            <a href={settings.instagram} target="_blank" rel="noreferrer" data-testid="booking-instagram-link"
              className="inline-flex items-center gap-2 border border-white/25 font-mono2 text-[11px] tracking-[0.25em] uppercase px-7 py-4 hover:border-white transition-colors duration-300">
              <Instagram size={14} /> Instagram
            </a>
          )}
        </div>
      )}
    </section>
  );
};
